import { emailVerificationConstants, emptyString } from "../../constants";
import { globalConstants } from "../../constants/global.constants";

const { SUCCESS, FAILURE } = globalConstants;
const { VERIFY_EMAIL } = emailVerificationConstants;

const initialState = {
  verifyEmail: emptyString,
};

//Exporting reducer for other screens
export const emailVerificationReducer = (state = initialState, action) => {
  if (
    action.type === VERIFY_EMAIL + SUCCESS ||
    action.type === VERIFY_EMAIL + FAILURE
  ) {
    return { ...state, verifyEmail: action.data };
  }
  return state;
};
